import { BehaviorSubject } from "rxjs";
import CookieStorage from "../../../utils/CookieStorage";

export type FilterLabels = {
  otById: Record<string, string>;
  procedureById: Record<string, string>;
  surgeonById: Record<string, string>;
  nurseById: Record<string, string>;
  anesthById: Record<string, string>;
  delayById: Record<string, string>;
};

export const initialFilterLabels: FilterLabels = {
  otById: {},
  procedureById: {},
  surgeonById: {},
  nurseById: {},
  anesthById: {},
  delayById: {},
};

const filterLabels$ = new BehaviorSubject<FilterLabels>(initialFilterLabels);
CookieStorage.init("filterLabels", filterLabels$);

export default filterLabels$;

export const getFilterLabels = () => filterLabels$.getValue();
export const updateFilterLabels = (patch: Partial<FilterLabels>) => {
  filterLabels$.next({ ...filterLabels$.getValue(), ...patch });
};
